import { createContext, useContext } from 'react';
import type { Data, Entity, Page } from './types';
export type CRMContext = {
  data: Data;
  refresh: () => Promise<void>;
  notify: (text: string, type?: 'success' | 'error') => void;
  navigate: (page: Page) => void;
  openContact: (contact: Entity) => void;
  openCreate: (type: string, defaults?: Record<string, any>) => void;
  mutate: (path: string, method?: string, body?: unknown) => Promise<any>;
};
export const CRM = createContext<CRMContext>(null!);
export const useCRM = () => useContext(CRM);
